import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export default function LikeButton({ collectionId, initialLikes = 0, initialLiked = false, className = "" }) {
  const { user, login } = useAuth();
  const [likes, setLikes] = useState(initialLikes);
  const [liked, setLiked] = useState(initialLiked);
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    if (!user) {
      toast("Sign in to love collections");
      login();
      return;
    }
    if (busy) return;
    setBusy(true);
    // optimistic
    setLiked((p) => !p);
    setLikes((n) => n + (liked ? -1 : 1));
    try {
      const r = await api.post(`/collections/${collectionId}/like`);
      setLikes(r.data.likes);
      setLiked(r.data.liked);
    } catch (e) {
      setLiked(liked);
      setLikes(likes);
      toast.error("Could not update");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="like-button"
      onClick={toggle}
      aria-pressed={liked}
      className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${
        liked ? "bg-brick/10 border-brick text-brick" : "border-stoneline text-ink hover:border-brick hover:text-brick"
      } ${className}`}
    >
      <Heart className={`h-4 w-4 ${liked ? "fill-brick" : ""}`} />
      <span data-testid="like-count">{likes}</span>
    </button>
  );
}
